import { render } from "./AttendanceStudentList.vue?vue&type=template&id=25601fc4"
import script from "./AttendanceStudentList.vue?vue&type=script&lang=js"
export * from "./AttendanceStudentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__